<template>
    <div class="info-container">
        <img class="info-icon" :src="require('@/assets/icons/info-icon.svg')" alt="Info icon"/> 
        {{ infoText }}
        <img v-if="transect_status == 3 || serie_status == 3" class="loading-icon" :src="require('@/assets/icons/spinner.gif')" alt="loading"/> 
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'info',
    
    data: function () {
        return {
            infoText: ""
        }
    },
    computed: {
        ...mapGetters(
            "map_params", {
                transect_status: 'transect_status',
                serie_status: 'serie_status',
                stations_or_density: 'stations_or_density',
            }
        ),
    },
    watch: {
        'transect_status': function () {
            this.manageTransectStatus()
        },
        'serie_status': function () {
            this.manageTransectStatus()
        }
    },
    mounted() {
        this.manageTransectStatus()
    },
    methods: {
        manageTransectStatus: function () {
            if(this.stations_or_density[2] == 'transect'){
                if(this.transect_status == 0) {
                    this.infoText = "Dibuje un transecto para comenzar." 
                }
                else if(this.transect_status == 1 || this.transect_status == 2) {
                    this.infoText = "Seleccione dos puntos en el mapa para dibujar un transecto." 
                }
                else if(this.transect_status == 3) {
                    this.infoText = "Calculando datos. Por favor, espere."
                }
            }
            if(this.stations_or_density[3] == 'serie_temp'){
                if(this.serie_status == 0) {
                    this.infoText = "Seleccione el botón 'Serie temporal MM' para mostrar la evolución del parámetro en el conjunto del Mar Menor. Seleccione 'Dibujar transecto' para mostrar la evolución del parámetro entre dos puntos. Tenga en cuenta que el filtro establecido afecta a los valores que se utilizan para el cálculo, por ejemplo las fechas de inicio y fin delimitan el rango de la serie temporal visualizada." 
                }
                else if(this.serie_status == 1 || this.serie_status == 2) {
                    this.infoText = "Seleccione dos puntos en el mapa para dibujar un transecto." 
                }
                else if(this.serie_status == 3) {
                    this.infoText = "Calculando datos. Por favor, espere."
                }
            }
        }      
    }
  }
</script>

<style scoped>
    .info-container {
        /* position: absolute;
        top: 20px;
        left: 20px; */
        background-color: #f4fafe;
        z-index: 1000000;
        color: #447998;
        font-size: 0.9rem;
        padding: 20px;
        border-radius: 25px;
        box-shadow: 0px 3px 3px rgba(0,0,0,0.3);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .info-icon {
        width: 40px;
        height: 40px;
        margin-right: 20px;
    }
    .loading-icon {
        height: 60px;
        margin-top: -20px;
        margin-bottom: -20px;
        width: 60px;
        margin-right: -6px;
        margin-left: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/mapparams/info.vue